import {
  Kontoausgleiche,
  mappedKontoausgleicheArt,
} from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import { Feiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/entities/Feiertagskonto';
import { GET_FEIERTAGSKONTO } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useFeiertagskonto/graphql/queries';
import { useSuspenseQuery } from '@apollo/client/react';

export function useFeiertagskonto({
  mitarbeiterId,
  zeitraum,
}: {
  mitarbeiterId: string;
  zeitraum: { von: string; bis: string };
}): Feiertagskonto {
  const response = useSuspenseQuery(GET_FEIERTAGSKONTO, {
    variables: {
      mitarbeiterByIds: mitarbeiterId,
      zeitraum: {
        von: zeitraum.von,
        bis: zeitraum.bis,
      },
    },
  });

  const [mitarbeiterById] = response.data.mitarbeiter_mitarbeiterByIds;

  const isFeiertagskontoAktive =
    mitarbeiterById.feiertagskontoEinstellungen.isFeiertagskontoEnabled;
  const mitarbeiterName = `${mitarbeiterById.vorname} ${mitarbeiterById.nachname}`;

  const kontoausgleicheMap = mitarbeiterById.feiertagskonto.kontoausgleiche;

  const kontoausgleiche: Kontoausgleiche[] = kontoausgleicheMap.map(
    (ausgleiche) => ({
      art: mappedKontoausgleicheArt(ausgleiche.art),
      bemerkung: ausgleiche.bemerkung,
      tage: ausgleiche.tage,
      datum: ausgleiche.datum,
    }),
  );

  return { isFeiertagskontoAktive, mitarbeiterName, kontoausgleiche };
}
